<template>
    <!-- 出价 -->
    <Modal v-model="show.dailyBudget" width="500" class="c-modal c-budget" @on-ok="regbudget">
        <p slot="header" class="modal-header">每日预算</p>
        <div class="modal-detail">
            <div class="modal-row">
                <Input
                    class="modal-row-input"
                    v-model.trim="budget"
                    @on-keyup="(e)=>mixinRegNum(e, 0)"
                    @on-change="(e)=>mixinRegNum(e, 0)"
                    :maxlength="8"
                    placeholder="请输入大于0的预算，不填为不限"
                >
                    <Select v-model="budgetType" slot="prepend" style="line-height: 36px;width:80px;">
                        <Option value="dailyBudget">花费</Option>
                        <Option value="dailyImp">展示</Option>
                        <Option value="dailyClick">点击</Option>
                    </Select>
                    <span v-if="budgetType=='dailyBudget'" slot="append">美元</span>
                    <span v-if="budgetType=='dailyImp'" slot="append">千次</span>
                    <span v-if="budgetType=='dailyClick'" slot="append">次</span>
                </Input>
                <Icon v-if="!reg.budget" type="android-cancel" class="icon-error"></Icon>
            </div>
        </div>
        <!-- 底部按钮 -->
        <div slot="footer">
            <Button type="text" @click="onCancel">取消</Button>
            <Button type="primary" size="large" @click="regbudget">保存</Button>
        </div>
    </Modal>
    <!-- 出价 -->
</template>
<script>
import common from '@/utils/common';
import mixins from '@/mixins/index.js';
export default {
    name: 'cbid',
    mixins: [mixins],
    props: {
        //请求对象
        type: {
            type: String,
        },
        show: {
            type: Object,
        },
    },
    data() {
        return {
            budgetType: 'dailyBudget',
            budget: '',
            reg: {
                budget: true, //验证
            },
        };
    },
    watch: {
        'show.dailyBudget'(bool) {
            if (bool) {
                this.budget = '';
                this.budgetType = 'dailyBudget';
                this.reg.budget = true;
            }
        },
    },
    methods: {
        onCancel() {
            this.show.dailyBudget = false;
            this.budget = '';
        },
        /**
         * @desc: 验证是否填写了budget
         */
        regbudget() {
            if (this.budget > 0 || !this.budget.length) {
                this.reg.budget = true;
                this.show.dailyBudget = false;
                this.$emit('save', { type: this.budgetType, value: this.budget });
            } else {
                this.reg.budget = false;
                this.$Message.error({
                    content: '请输入大于0的预算',
                    duration: 1.5,
                });
            }
        },
    },
};
</script>
<style lang="scss">
@import 'src/style/frequently.scss';
@import 'src/style/cModal.scss';
.c-budget {
    .ivu-input-group-prepend,
    .ivu-input-group-append {
        background: none;
        font-size: 0.14rem;
        width: 0.7rem;
        & > span {
            position: relative;
            top: 1px;
        }
    }
    .ivu-select {
        position: relative;
        z-index: 1000;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/cBudgetSimple.vue